var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.modules.cards
      ? _c(
          "div",
          {
            staticClass:
              "mobile-wrapper column px-gap ww-12/12 flex flex-wrap w-full justify-between align-middle pt-2",
          },
          [
            _c(
              "Swiper",
              {
                ref: "soundSwiper",
                staticClass: "h-full w-full",
                attrs: { options: _vm.contentOptions },
              },
              _vm._l(_vm.modules.cards, function (card, index) {
                return _c("SwiperSlide", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full flex justify-center m-auto items-center border-blue-default hover:bg-blue-darker border-1 rounded-md product-hover-card hover:border-0",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.playAudio(index)
                        },
                      },
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "my-0 markdown" },
                          [
                            card.fields.content
                              ? _c("Markdown", {
                                  attrs: { source: card.fields.content },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        card.fields.link
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "btn--audio no-underline hover:no-underline font-medium mt-auto inline-block md:mb-1 lg:mb-0 cursor-pointer",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.get(
                                        card,
                                        "fields.cta[0].fields.text",
                                        "Hear in cab alert"
                                      )
                                    )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      card.fields.link
                        ? _c("audio", {
                            ref: `alert-${index}`,
                            refInFor: true,
                            attrs: {
                              "data-src": card.fields.link,
                              preload: "none",
                              autoplay: "false",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ])
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bullets" },
              _vm._l(_vm.modules.cards, function (slide, index) {
                return _c("span", {
                  key: index,
                  staticClass: "bullet",
                  class: { active: index + 1 === _vm.active },
                  attrs: { tabindex: "0" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return (() => {
                        _vm.goToSlide(index + 1)
                        _vm.touched = false
                      }).apply(null, arguments)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return (() => {
                        _vm.goToSlide(index + 1)
                        _vm.touched = false
                      }).apply(null, arguments)
                    },
                  },
                })
              }),
              0
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.modules.cards
      ? _c(
          "div",
          {
            staticClass:
              "desktop-wrapper w-full column px-gap ww-12/12 flex flex-wrap w-full justify-between align-middle",
            staticStyle: { "min-height": "320px" },
          },
          _vm._l(_vm.modules.cards, function (card, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "w-full flex justify-center m-auto items-center border-blue-default hover:bg-blue-darker border-1 rounded-md product-hover-card hover:border-0",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.playAudio(index)
                  },
                },
              },
              [
                _c("div", [
                  _c(
                    "span",
                    { staticClass: "my-0 markdown" },
                    [
                      card.fields.content
                        ? _c("Markdown", {
                            attrs: { source: card.fields.content },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  card.fields.link
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "btn--audio no-underline hover:no-underline font-medium mt-auto inline-block md:mb-1 lg:mb-0 cursor-pointer",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.get(
                                  card,
                                  "fields.cta[0].fields.text",
                                  "Hear in cab alert"
                                )
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                card.fields.link
                  ? _c("audio", {
                      ref: `alert-${index}`,
                      refInFor: true,
                      attrs: {
                        "data-src": card.fields.link,
                        preload: "none",
                        autoplay: "false",
                      },
                    })
                  : _vm._e(),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }